module.exports = __webpack_public_path__ + "img/horizontal-bar-chart-03.12e100bd.svg";